import { elakay_API } from "../../config";
import { decryptData } from "./elakayCryptage";
import { readUploadResponse } from "../../utils/uploadResponse";

const parseApiResponse = async (response) => {
  // Any failure (including a proxy's HTML 413 page) becomes a readable
  // French message instead of a JSON parse error.
  if (!response.ok) await readUploadResponse(response);
  const data = await response.json();

  if (data?.ciphertext && data?.iv && data?.salt && data?.tag) {
    return decryptData(data);
  }

  return data;
};

const authHeaders = (token) => ({
  Accept: "application/json",
  Authorization: `Bearer ${token}`
});

export const listDeliveryOrders = async (token, filters = {}) => {
  const params = new URLSearchParams();
  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      params.set(key, value);
    }
  });

  const response = await fetch(`${elakay_API}/delivery/orders?${params.toString()}`, {
    headers: authHeaders(token)
  });

  return parseApiResponse(response);
};

export const lookupDeliveryOrder = async (token, tracking) => {
  const params = new URLSearchParams({ tracking: String(tracking || "").trim() });
  const response = await fetch(
    `${elakay_API}/delivery/lookup?${params.toString()}`,
    { headers: authHeaders(token) }
  );

  return parseApiResponse(response);
};

export const getDeliveryOrder = async (token, orderId, orderProductId) => {
  const response = await fetch(
    `${elakay_API}/delivery/order/${orderId}/${orderProductId}`,
    { headers: authHeaders(token) }
  );

  return parseApiResponse(response);
};

export const updateDeliveryOrder = async (
  token,
  orderId,
  orderProductId,
  formData
) => {
  const response = await fetch(
    `${elakay_API}/delivery/order/${orderId}/${orderProductId}`,
    {
      method: "PATCH",
      headers: {
        Authorization: `Bearer ${token}`
      },
      body: formData
    }
  );

  return parseApiResponse(response);
};

export const getDeliveryProofUrl = (
  orderId,
  orderProductId,
  proofId
) => `${elakay_API}/delivery/order/${orderId}/${orderProductId}/proof/${proofId}`;

export const loadDeliveryProof = async (
  token,
  orderId,
  orderProductId,
  proofId
) => {
  const response = await fetch(
    getDeliveryProofUrl(orderId, orderProductId, proofId),
    { headers: { Authorization: `Bearer ${token}` } }
  );

  if (!response.ok) {
    let message = `HTTP ${response.status}`;
    try {
      const data = await response.json();
      message = data.error || message;
    } catch {
      // The proof endpoint normally returns binary data.
    }
    throw new Error(message);
  }

  return URL.createObjectURL(await response.blob());
};

export const deleteDeliveryProof = async (
  token,
  orderId,
  orderProductId,
  proofId
) => {
  const response = await fetch(
    getDeliveryProofUrl(orderId, orderProductId, proofId),
    {
      method: "DELETE",
      headers: authHeaders(token)
    }
  );

  return parseApiResponse(response);
};
